import { render, staticRenderFns } from "./MedicalServicesComponent.vue?vue&type=template&id=649a2e6a&scoped=true"
import script from "./MedicalServicesComponent.vue?vue&type=script&lang=js"
export * from "./MedicalServicesComponent.vue?vue&type=script&lang=js"
import style0 from "./MedicalServicesComponent.vue?vue&type=style&index=0&id=649a2e6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649a2e6a",
  null
  
)

export default component.exports